<template>
  <div>
    <CRow>
      <CCol lg="12" v-if="filter">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol lg="12" sm="12">
                <label><strong>Statistik Tokomu</strong></label>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="8">
                <CRow>
                  <CCol lg="3">
                    <model-select
                      class="form-control"
                      id="bulan"
                      v-model="currentMonth"
                      :options="filter.month"
                      placeholder="-- Silahkan pilih bulan --"
                    ></model-select>
                  </CCol>

                  <CCol lg="3">
                    <model-select
                      class="form-control"
                      id="tahun"
                      v-model="currentYear"
                      :options="filter.year"
                      placeholder="-- Silahkan pilih tahun --"
                    ></model-select>
                  </CCol>
                  <CCol lg="4">
                    <model-select
                      class="form-control"
                      id="filterAgent"
                      :options="agentList"
                      v-model="agent"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                  </CCol>
                  <CCol sm="2">
                    <CButton
                      size="sm"
                      @click="getDashboard"
                      color="linkedin"
                      name="linkedin"
                    >
                      <i class="fa fa-plus-square"></i>&nbsp;
                      <span>Search</span>
                    </CButton>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="12" sm="12"><br /></CCol>
            </CRow>
            <CRow>
              <CCol sm="6" lg="3">
                <CWidgetProgress
                  footer="*Hanya menghitung Orderan dengan status Berhasil"
                >
                  <div class="h4 m-0">Total Transaksi</div>
                  <div class="card-header-action">
                    <small
                      class="card-header-action position-absolute"
                      style="right: 5px; top: 5px"
                      >{{ currMonYearView }}</small
                    >
                  </div>
                  <div>
                    <small>{{ currAgentView }}</small>
                  </div>
                  <div class="h5 mt-10">Rp. {{ data.total_transaction }}</div>
                </CWidgetProgress>
              </CCol>
              <CCol sm="6" lg="3">
                <CWidgetProgress
                  footer="*Hanya menghitung Orderan dengan status Berhasil"
                >
                  <div class="h4 m-0">Total Order</div>
                  <div class="card-header-action">
                    <small
                      class="card-header-action position-absolute"
                      style="right: 5px; top: 5px"
                      >{{ currMonYearView }}</small
                    >
                  </div>
                  <div>
                    <small>{{ currAgentView }}</small>
                  </div>
                  <div class="h5 mt-10">{{ data.total_order }}</div>
                </CWidgetProgress>
              </CCol>
              <CCol sm="6" lg="3">
                <CWidgetProgress
                  footer="*Hanya menghitung Orderan dengan status Berhasil"
                >
                  <div class="h4 m-0">Total Produk Terjual</div>
                  <div class="card-header-action">
                    <small
                      class="card-header-action position-absolute"
                      style="right: 5px; top: 5px"
                      >{{ currMonYearView }}</small
                    >
                  </div>
                  <div>
                    <small>{{ currAgentView }}</small>
                  </div>
                  <div class="h5 mt-10">{{ data.total_product }}</div>
                </CWidgetProgress>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="12" sm="12">
                <div v-if="orderLoad">
                  <loading></loading>
                </div>
                <div v-else>
                  <OrderChart :label="label" :data-set="chart" style="margin-top: 40px" />
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import OrderChart from "./charts/OrderChart";
import ProductChart from "./charts/ProductChart";
import ChartBar from "./charts/ChartBar";
import Loading from "../../templates/Loading.vue";
import tableInterfaces from "@/templates/_table_interfaces.js";
import axios from "axios";
import * as moment from "moment";
import { ModelSelect } from "vue-search-select";

export default {
  name: "Dashboard",
  components: { Loading, ModelSelect, OrderChart },
  data() {
    return {
      data: [],
      chart: [],
      label: [],
      agent: null,
      agentList: [],
      orderLoad: false,
      filter: {
        year: [],
        month: [],
      },
      title: "Dashboard",
      isLoading: false,
      currentMonth: moment().format("MM"),
      currentYear: moment().format("YYYY"),
      currMonYearView: null,
      currAgentView: null,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.getDropdown();
      this.getDashboard();
      this.getDropdownAgent();
    },
    getDropdown: function () {
      this.axios.get("console/dropdown/month-year").then((response) => {
        this.filter = response.data.data;
      });
    },
    getDropdownAgent: function () {
      this.axios.get("/console/dropdown/export-product").then((response) => {
        this.agentList = response.data.agent;
      });
    },

    getDashboard: function () {
      let param = {};
      param.month = this.currentMonth;
      param.year = this.currentYear;
      param.agent_code = this.agent;
      this.createView();
      this.axios
        .post("console/dashboard/seller/transaction", param)
        .then((response) => {
          if (response.data.status === 2000) {
            this.data = response.data.data;
            this.chart = response.data.order;
            this.label = response.data.label;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    createView: function () {
      let mon = moment(this.currentYear + "-" + this.currentMonth + "-01").format("MMMM");
      if (this.agent !== null) {
        this.agentList.forEach((element) => {
          if (element.value === this.agent) {
            this.currAgentView = element.text;
          }
        });
      } else {
        this.currAgentView = "All Seller";
      }
      this.currMonYearView = mon + " " + this.currentYear;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
